<template>
    <div class="home-projects-section" v-if="pageSetup != null">
        <div class="container">
            <div class="project-items-content">
                <div class="project-item">
                    <div class="item-bg" :style="'background-image: url(' + pageSetup.built_projects.img + ')'">
                        <router-link to="/projects/built">
                            <h2>{{ pageSetup.built_projects.title }}</h2>
                        </router-link>
                    </div>
                    <div class="item-list">
                        <ul>
                            <li v-for="item in pageSetup.built_projects.project_list.slice(0, 4)"><router-link :to="{ name : 'project-card' , params:{id : item.project.post_name, 'pageID': 'built'}}">{{ item.project.post_title }}</router-link></li>
                        </ul>
                        <ul v-if="pageSetup.built_projects.project_list.length > 4">
                            <li v-for="item in pageSetup.built_projects.project_list.slice(4, 8)"><router-link :to="{ name : 'project-card' , params:{id : item.project.post_name, 'pageID': 'built'}}">{{ item.project.post_title }}</router-link></li>
                        </ul>
                    </div>
                </div>
                <div class="project-item">
                    <div class="item-bg" :style="'background-image: url(' + pageSetup.current_projects.img + ')'">
                        <router-link to="/projects/construction">
                            <h2>{{ pageSetup.current_projects.title }}</h2>
                        </router-link>
                    </div>
                    <div class="item-list">
                        <ul>
                            <li v-for="item in pageSetup.current_projects.project_list.slice(0, 4)"><router-link :to="{ name : 'project-card' , params:{id : item.project.post_name, 'pageID': 'construction'}}">{{ item.project.post_title }}</router-link></li>
                        </ul>
                        <ul v-if="pageSetup.current_projects.project_list.length > 4">
                            <li v-for="item in pageSetup.current_projects.project_list.slice(4, 8)"><router-link :to="{ name : 'project-card' , params:{id : item.project.post_name, 'pageID': 'construction'}}">{{ item.project.post_title }}</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'home-projects-section',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            pageSetup: 'loadIndexPage',
        }),
        methods: {
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/home-page/home-projects.scss';
    @import '@/styles/components/home-page/respond/home-projects-respond.scss';
</style>